// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"48":"result-page","79":"processing-static-page","185":"widget-page","285":"redirect-page"}[chunkId] || chunkId) + "." + {"48":"2f296d51","79":"705710d9","109":"ad204922","185":"eba2d5aa","200":"12322b59","285":"8f270133","974":"2dc6285e"}[chunkId] + ".js";
};